import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=d1d53724&scoped=true&"
import script from "./LayoutMain.vue?vue&type=script&lang=js&"
export * from "./LayoutMain.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=d1d53724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d53724",
  null
  
)

export default component.exports